import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "../ui/button";

export function CustomerPagination({ page, pages, total, onPageChange }) {
  if (pages <= 1) return null;
  return (
    <div className="flex items-center justify-between mt-4" data-testid="pagination">
      <p className="text-sm text-slate-500">
        Pagina {page} de {pages} ({total} resultados)
      </p>
      <div className="flex gap-2">
        <Button
          variant="outline"
          size="sm"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
          className="border-slate-700 text-slate-400"
        >
          <ChevronLeft size={16} />
        </Button>
        <Button
          variant="outline"
          size="sm"
          disabled={page >= pages}
          onClick={() => onPageChange(page + 1)}
          className="border-slate-700 text-slate-400"
        >
          <ChevronRight size={16} />
        </Button>
      </div>
    </div>
  );
}
